import { render } from "./Event.vue?vue&type=template&id=4ff9ddc3&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=4ff9ddc3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ff9ddc3"

export default script